import { createContext, useCallback, useContext, useEffect, useState } from "react";
import * as api from "../api/client";

const DashboardsContext = createContext(null);

export function DashboardsProvider({ children }) {
  const [dashboards, setDashboards] = useState([]);

  const refresh = useCallback(async () => {
    try {
      setDashboards(await api.listDashboards());
    } catch {
      // best-effort, same as the conversation sidebar
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  const removeDashboard = useCallback((id) => {
    setDashboards((prev) => prev.filter((d) => d.id !== id));
  }, []);

  return (
    <DashboardsContext.Provider value={{ dashboards, refresh, removeDashboard }}>
      {children}
    </DashboardsContext.Provider>
  );
}

export function useDashboards() {
  const ctx = useContext(DashboardsContext);
  if (!ctx) throw new Error("useDashboards must be used within a DashboardsProvider");
  return ctx;
}
